import { Divider as DividerAntd, DividerProps } from 'antd';
import classNames from 'classnames';
import { memo } from 'react';

export const Divider = memo(({ className, ...rest }: DividerProps) => {
  return <DividerAntd className={classNames('ctv-divider', className)} {...rest} />;
});

Divider.displayName = 'Divider';
